app.factory("QuestionnairesService", ["$http", "$log",
    function ($http) {
        var QuestionnairesService = {};

        QuestionnairesService.addTemplate = function (template) {
            return $http.post("/questionnaires/template", template).then(function (resp) {
                return resp.data;
            });
        };

        QuestionnairesService.deleteTemplate = function (templateId) {
            return $http.delete("/questionnaires/template/" + templateId).then(function (resp) {
                return resp.data
            })
        };

        QuestionnairesService.getTemplateList = function (params) {
            return $http.get("/questionnaires/template/list/", {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 25,
                    query: params.query,
                    type: params.type,
                    fromDate: params.fromDate,
                    toDate: params.toDate
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        QuestionnairesService.create = function (questionnaire) {
            return $http.post("/questionnaires", questionnaire).then(function (resp) {
                return resp.data;
            });
        };

        QuestionnairesService.edit = function (questionnaire) {
            return $http.put("/questionnaires/template", questionnaire).then(function (resp) {
                return resp.data
            })
        };


        QuestionnairesService.remove = function (questionnaireId) {
            return $http.delete("/questionnaires/" + questionnaireId).then(function (resp) {
                return resp.data
            })
        };

        QuestionnairesService.list = function (params) {
            return $http.get("/questionnaires/list/", {
                params: {
                    template: params.template,
                    page: params.page || 1,
                    limit: params.limit || 25,
                    query: params.query,
                    type: params.type,
                    fromDate: params.fromDate,
                    toDate: params.toDate
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        QuestionnairesService.getTemplateById = function (questionnaireId) {
            return $http.get("/questionnaires/template/" + questionnaireId).then(function (resp) {
                return resp.data
            })
        };

        QuestionnairesService.getById = function (questionnaireId) {
            return $http.get("/questionnaires/" + questionnaireId).then(function (resp) {
                return resp.data
            })
        };

        QuestionnairesService.send = function (questionnaire, counts) {
            return $http.post("/questionnaires/send", { questionnaire: questionnaire, counts }).then(function (resp) {
                return resp.data;
            });
        };

        QuestionnairesService.updateMandatory = function (params) {
            return $http.put("/questionnaires/update/mandatory/" + params.questionnaireId, params).then(function (resp) {
                return resp.data;
            });
        };

        QuestionnairesService.answer = function (params) {
            return $http.post("/questionnaires/" + params.questionnaireId + "/section/answers", params).then(function (resp) {
                return resp.data;
            });
        };

        QuestionnairesService.ignore = function (questionnaireInfoId) {
            return $http.put("/questionnaires/info/ignore/" + questionnaireInfoId).then(function (resp) {
                return resp;
            });
        }

        QuestionnairesService.getInfoByProfile = function (profileId) {
            return $http.get("/questionnaires/info/" + profileId).then(function (resp) {
                return resp;
            });
        };

        QuestionnairesService.getListByProfile = function (profileId) {
            return $http.get("/questionnaires/infos/" + profileId).then(function (resp) {
                return resp.data;
            });
        };

        QuestionnairesService.exportStatistics = function (id) {
            var url = "/questionnaires/export/" + id;
            window.open(url);
        };

        QuestionnairesService.getVersions = function (questionnaireId) {
            return $http.get("/questionnaires/template/versions/" + questionnaireId).then(function (resp) {
                return resp.data
            })
        };

        QuestionnairesService.getReceiversListForLecturer = function (params) {
            return $http.get("/questionnaires/receivers/list/forLecturer", {
                params
            }).then(function (resp) {
                return resp.data;
            });
        };

        return QuestionnairesService;
    }
]);
